module.exports = __webpack_public_path__ + "media/images/logo__majesticksgc-c84d9d9be2faedc0deccad2c97ad38eb.png";